import { Accept } from 'react-dropzone';
import { NameByValue } from '@/types';
import { DonorType, Laterality, NRPOption, NRPType, OrganType, ServiceType } from '@/api/apis/case';

export const FILE_TYPES: Accept = {
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/pdf': ['.pdf'],
  'video/*': ['.mov', '.mp4', '.hevc'],
  'image/*': ['.jpg', '.jpeg', '.png', '.heic'],
};

export const DOCUMENT_FILE_TYPES: Accept = {
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
  'application/pdf': ['.pdf'],
};

export const ORGAN_TYPES: NameByValue<OrganType, string>[] = [
  { value: OrganType.Liver, name: 'Liver' },
  { value: OrganType.Heart, name: 'Heart' },
  { value: OrganType.Lungs, name: 'Lungs' },
  { value: OrganType.Kidney, name: 'Kidney' },
];

export const LATERALITY_OPTIONS: NameByValue<Laterality, string>[] = [
  { value: Laterality.Left, name: 'Left' },
  { value: Laterality.Right, name: 'Right' },
];

export const DONOR_TYPES: NameByValue<DonorType, string>[] = [
  { value: DonorType.DCD, name: 'DCD' },
  { value: DonorType.DBD, name: 'DBD' },
];

export const NRP_OPTIONS: NameByValue<NRPOption, string>[] = [
  { value: NRPOption.Yes, name: 'Yes' },
  { value: NRPOption.No, name: 'No' },
];

export const NRP_TYPES: NameByValue<NRPType, string>[] = [
  { value: NRPType.aNrp, name: 'A-NRP' },
  { value: NRPType.taNrp, name: 'TA-NRP' },
];

export const SERVICE_TYPES: NameByValue<ServiceType, string>[] = [
  { value: ServiceType.NopWithTmdxSurgeon, name: 'NOP with TMDX Surgeon' },
  { value: ServiceType.NopWithoutTmdxSurgeon, name: 'NOP without TMDX Surgeon' },
  { value: ServiceType.DirectAcquisition, name: 'Direct Acquisition' },
];
